import { render, staticRenderFns } from "./ProgramItem.vue?vue&type=template&id=a192d8f4&scoped=true"
import script from "./ProgramItem.vue?vue&type=script&lang=js"
export * from "./ProgramItem.vue?vue&type=script&lang=js"
import style0 from "./ProgramItem.vue?vue&type=style&index=0&id=a192d8f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a192d8f4",
  null
  
)

export default component.exports